export const FETCH_ROLE_MODULES = 'FETCH_ROLE_MODULES';
export const FETCH_ROLE_MODULES_OK = 'FETCH_ROLE_MODULES_OK';
export const FETCH_ROLE_MODULES_FAILED = 'FETCH_ROLE_MODULES_FAILED';

export const FETCH_ROLE_PERMISSIONS = 'FETCH_ROLE_PERMISSIONS';
export const FETCH_ROLE_PERMISSIONS_OK = 'FETCH_ROLE_PERMISSIONS_OK';
export const FETCH_ROLE_PERMISSIONS_FAILED = 'FETCH_ROLE_PERMISSIONS_FAILED';

export const ATTACH_MODULE = 'ATTACH_MODULE';
export const ATTACH_MODULE_OK = 'ATTACH_MODULE_OK';
export const ATTACH_MODULE_FAILED = 'ATTACH_MODULE_FAILED';

export const RESET_ROLE_MODULE = 'RESET_ROLE_MODULE';